import NestedForm from "stimulus-rails-nested-form"

export default class extends NestedForm {
  connect() {
    super.connect()
    console.log("Frontend nested form controller connected")
    console.log("Wrapper selector:", this.wrapperSelectorValue)
  }

  remove(event) {
    console.log("Remove button clicked", event.target)
    console.log("Event target closest wrapper:", event.target.closest(this.wrapperSelectorValue))
    super.remove(event)
  }
}
